<template lang="html">
    <fleets v-if="displayFleetsPageWhenNoSelectedFleet"></fleets>
    <simple-layout v-else class="inspections-page" :modelsLoaded="true" :indicators="simpleLayoutIndicators">
        <color-modal ref="color-modal" @refreshPaginate="refreshPaginate"></color-modal>
        <el-row>
            <el-col :span='16'>
                <h1>Véhicules</h1>
            </el-col>
            <el-col :span='8'>
                <select-group v-if="displaySelectGroup" class="select-group-component"></select-group>
            </el-col>
        </el-row>
        <div>
            <p>Sélectionner les véhicules que vous souhaitez inspecter le même jour et cliquer sur le bouton
                <strong>Créer des requêtes d'inspection</strong> en <strong>bas à droite</strong> de la page.
            </p>
        </div>

        <el-button v-if="userIsAtLeastAdmin" type="primary" @click="openColorModal"
            class="color-selection-button">Paramétrer les couleurs</el-button>

        <div>
            <ns-vue-loader ref="nsLoader" :toLoad="toLoad" @dataFetched="onDataFetched">
                <div slot="content">
                    <ns-paginate ref="vehiclesTable" baseUrl="vehicle/" :listFieldToDisplay="listFieldToDisplay"
                        :customFiltersToApply="filterData" :scoped="false">
                        <template slot="list" slot-scope="props">
                            <el-table :data="props.list" :row-style="tableRowStyle"
                                @selection-change="handleSelectionChange">
                                <el-table-column v-if="!$store.getters.currentUser.is_client" type="selection"
                                    width="55">
                                </el-table-column>
                                <el-table-column label="Immat" prop="plate">
                                </el-table-column>
                                <el-table-column label="Nom de la base" prop="fleet_name" min-width="240">
                                </el-table-column>
                                <el-table-column label="Emplacement" prop="location_city">
                                </el-table-column>
                                <el-table-column label="Numéro de parc" prop="fleet_reference">
                                </el-table-column>
                                <el-table-column label="Type de la dernière inspection" prop="last_inspection_type">
                                </el-table-column>
                                <el-table-column label="Date de la dernière inspection" prop="last_inspection_date">
                                    <template slot-scope="scope">
                                        <span>{{ inspectionDate(scope.row.last_inspection_date) | moment('DD/MM/YYYY')
                                            }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="250" label="Statut de la requête d'inspection">
                                    <template slot-scope="scope">
                                        <div class="inspection-detail-container">
                                            <div>{{ inspectionStatus(scope.row) }}</div>
                                            <el-tooltip class="item" effect="dark"
                                                content="Voir les dernières requêtes d'inspection" placement="top">
                                                <el-button v-if="scope.row.inspection_requested" type="primary"
                                                    size="small" icon="el-icon-view"
                                                    @click="showInspectionsDetailsDialog(scope.row)"></el-button>
                                            </el-tooltip>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <span slot="csv-button">
                            <download-csv-button :context="getCsvContext(false)" :modelName="'vehicle'"
                                class="download-out-of-fleet-csv-button"
                                textButton="Télécharger l'XLSX"></download-csv-button>
                        </span>
                    </ns-paginate>
                    <span class="button-container">
                        <download-csv-button :context="getCsvContext(true)" :modelName="'vehicle'"
                            class="download-out-of-fleet-csv-button"
                            textButton="Exporter les véhicules sortis de base"></download-csv-button>
                        <el-button v-if="!$store.getters.currentUser.is_client" type="primary"
                            class="create-requests-button" :disabled="allowCreate" @click="openDialog">
                            Créer des requêtes d'inspection
                        </el-button>
                    </span>
                </div>
            </ns-vue-loader>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="displayDialog" :append-to-body="true">
            <span>Veuillez sélectionner une date d'inspection pour les véhicules sélectionnés.</span>
            <el-form ref='scheduleDateForm' :model="form" :rules="rules">
                <el-form-item prop="scheduledDate">
                    <el-date-picker v-model="form.scheduledDate" type="daterange" range-separator="à"
                        format="dd/MM/yyyy" start-placeholder="Date de début" end-placeholder="Date de fin">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetDialog">Annuler</el-button>
                <el-button type="primary" @click="createInspectionRequests(selectedVehicles)">Confirmer</el-button>
            </span>
        </el-dialog>
        <inspections-details-dialog ref="inspectionsDetailsDialog"></inspections-details-dialog>
    </simple-layout>
</template>

<script>
import Fleets from '../Fleets/Index.vue';
import SelectGroup from '@/components/partials/select-group.vue';
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate/index.vue';
import NsVueLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import colorModal from '../../partials/color-modal.vue';
import inspectionsDetailsDialog from './inspectionsDetailsDialog.vue';
import DownloadCsvButton from '@/components/partials/download-csv-button.vue';

export default {
    components: {
        Fleets,
        SelectGroup,
        NsPaginate,
        colorModal,
        NsVueLoader,
        inspectionsDetailsDialog,
        DownloadCsvButton
    },

    data() {
        return {
            displayDialog: false,
            selectedVehicles: [],
            inspectionRequests: [],
            inspectionRequestsArchived: [],
            form: {
                scheduledDate: '',
            },
            rules: {
                scheduledDate: [
                    { required: true, message: 'Veuillez sélectionner une période', trigger: 'change' }
                ],
            },
            vehicles: [],
            listFieldToDisplay: [
                {
                    key: 'selection',
                    verbose: 'Sélectionner ',
                },
                {
                    key: 'plate',
                    verbose: 'Immat ',
                },
                {
                    key: 'fleet_name',
                    verbose: 'Nom de la base ',
                },
                {
                    key: 'location_name',
                    verbose: 'Emplacement',
                },
                {
                    key: 'location_city',
                    verbose: 'Ville',
                },
                {
                    key: 'last_inspection_type',
                    verbose: 'Type de la dernière inspection',
                },
                {
                    key: 'last_inspection_date',
                    verbose: 'Date de la dernière inspection',
                }
            ],
        };
    },
    computed: {
        ...mapGetters([
            'getVehicleInspectionStatus',
            'getSelectedFleet',
            'selectedGroup',
            'displayFleetsPage',
            'isAFleetSelected',
            'displaySelectGroup',
            'simpleLayoutIndicators',
            'userIsAtLeastAdmin',
            'colorsConfig',
            'colorsConfigStatuses',
        ]),

        toLoad() {
            return [
                {
                    model: 'inspectionRequests',
                    name: 'inspectionRequests',
                    filters: {
                        client_group_uid: this.getSelectedFleet,
                    }
                }
            ];
        },

        dialogTitle() {
            return `Créer ${this.selectedVehicles.length > 1 ? 'des requêtes' : 'une requête'} d'inspection`;
        },

        allowCreate() {
            return this.selectedVehicles.length == 0;
        },

        displayFleetsPageWhenNoSelectedFleet() {
            return this.displayFleetsPage && !this.isAFleetSelected;
        },

        filterData() {
            return () => {
                return this.queryParams;
            };
        },

        userIsClient() {
            return this.$store.getters.currentUser.is_client;
        },

        queryParams() {
            if (this.isAFleetSelected) {
                return {
                    ordering: 'last_inspection_date,plate',
                    client_group: this.getSelectedFleet,
                    out_of_fleet: 'false',
                };
            } else {
                return {
                    ordering: 'last_inspection_date,plate',
                    out_of_fleet: 'false',
                };
            }
        },
    },

    watch: {
        // can't watch the getter value, as no changes are triggered when
        // the user as only one group, no explanation found yet
        '$store.state.selectedFleet'(val) {
            this.$set(this.queryParams, 'client_group', val);
            if (this.$refs['vehiclesTable']) {
                this.$refs['vehiclesTable'].loadContent();
            }
        },
    },

    methods: {
        getCsvContext(outOfFleet = false) {
            return {
                "out_of_fleet": outOfFleet,
                "client_group": this.getSelectedFleet,
                "model": "Vehicles"
            };
        },
        showInspectionsDetailsDialog(vehicle) {
            let inspectionRequest = [...this.inspectionRequests.filter(ir => vehicle.uid === ir.vehicle_uid), ...this.inspectionRequestsArchived.filter(ir => vehicle.uid === ir.vehicle_uid)];
            this.$refs.inspectionsDetailsDialog.open(vehicle, inspectionRequest);
        },
        inspectionStatus(vehicle) {
            let inspectionRequest = this.inspectionRequests.find(ir => vehicle.uid === ir.vehicle_uid);
            if (inspectionRequest && vehicle.inspection_requested === true) {
                if (inspectionRequest.client_has_answered) {
                    if (inspectionRequest.vehicle_available === true) {
                        return 'Acceptée';
                    } else {
                        return 'Refusée';
                    }
                } else {
                    if (inspectionRequest.rescheduled === true) {
                        return 'Re-plannifiée';
                    } else {
                        return 'En attente de réponse';
                    }
                }
            } else {
                return 'Aucune requête';
            }
        },
        resetDialog() {
            this.displayDialog = false;
            this.$set(this, 'form', {
                scheduledDate: '',
            });
        },
        openDialog() {
            this.displayDialog = true;
            this.$refs.scheduleDateForm.clearValidate();
        },
        rescheduleInspection(inspection, vehicle) {
            this.$store.dispatch('patchItem', {
                item: {
                    uid: inspection.uid,
                    url: inspection.url,
                    scheduled_date_start: this.formatDate(this.form.scheduledDate[0]),
                    scheduled_date_end: this.formatDate(this.form.scheduledDate[1]),
                },
                model: 'inspectionRequests'
            }).then(res => {
                // this.$notify.success({
                //     message: 'Replanification effectuée'
                // });
                this.$store.dispatch('createItem', {
                    item: {
                        name: `REPROGRAMMÉ - Date précédentes: ${inspection.scheduled_date_start} - ${inspection.scheduled_date_end}`,
                        inspection_request_uid: res.uid,
                        can_admin_groups: vehicle.can_admin_groups,
                        client_group_uid: vehicle.client_group_uid,
                        public: false,
                    },
                    model: 'inspectionRequestLogs',
                    url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                });
                // this.resetDialog();
            }).catch(() => {
                // this.$notify.error({
                //     message: 'Erreur lors de la replanification'
                // });
            });
        },
        onDataFetched(res) {
            this.$set(this, 'inspectionRequests', res.inspectionRequests.filter(ir => ir.archived === false));
            this.$set(this, 'inspectionRequestsArchived', res.inspectionRequests.filter(ir => ir.archived === true));
        },
        refreshPaginate() {
            this.$refs.vehiclesTable.loadContent();
        },

        openColorModal() {
            this.$refs['color-modal'].open(this.selectedGroup.base_uid);
        },

        inspectionDate(date) {
            if (date === '2000-01-01') {
                return 'jamais inspecté';
            }
            return date;
        },

        formatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },

        handleSelectionChange(val) {
            if (val) {
                this.selectedVehicles = val;
            }
        },

        createInspectionRequests(vehicles) {
            this.$refs['scheduleDateForm'].validate((valid) => {
                if (!this.getSelectedFleet) {
                    console.error('no selectedFleet');
                    this.$notify({
                        type: 'error',
                        title: 'Pas de flotte cliente trouvée',
                        message: 'Veuillez contacter un administrateur.'
                    });
                    return;
                }
                if (valid) {
                    vehicles.forEach((vehicle) => {
                        let inspectionRequest = this.inspectionRequests.find(ir => vehicle.uid === ir.vehicle_uid);
                        if (inspectionRequest && inspectionRequest.client_has_answered === false && vehicle.inspection_requested === true) {
                            this.rescheduleInspection(inspectionRequest, vehicle);
                        } else {
                            this.$store.dispatch('createItem', {
                                item: {
                                    plate: vehicle.plate,
                                    scheduled_date_start: this.formatDate(this.form.scheduledDate[0]),
                                    scheduled_date_end: this.formatDate(this.form.scheduledDate[1]),
                                    vehicle_uid: vehicle.uid,
                                    fleet_reference: vehicle.fleet_reference,
                                    client_group_uid: vehicle.client_group_uid,
                                    can_admin_groups: vehicle.can_admin_groups,
                                },
                                model: 'inspectionRequests',
                                url: this.$store.state.api.meta.listModels.inspectionRequests.url,
                            }).then((value) => {
                                this.$store.dispatch('patchItem', {
                                    item: {
                                        inspection_requested: true,
                                        url: vehicle.url,
                                    },
                                    model: 'vehicles',
                                }).then(() => {
                                    this.$refs['vehiclesTable'].loadContent();
                                    this.$store.dispatch('createItem', {
                                        item: {
                                            name: 'CRÉÉ',
                                            inspection_request_uid: value.uid,
                                            can_admin_groups: vehicle.can_admin_groups,
                                            client_group_uid: vehicle.client_group_uid,
                                            public: false,
                                        },
                                        model: 'inspectionRequestLogs',
                                        url: this.$store.state.api.meta.listModels.inspectionRequestLogs.url,
                                    });
                                });
                            }).catch((error) => {
                                console.error(error);
                                this.$notify({
                                    type: 'error',
                                    title: 'Échec',
                                    message: "Il y a eu une erreur lors de la création de requêtes d'inspection. Veuillez réessayer ou bien contacter un administrateur pour plus d'information"
                                });
                            });
                        }
                    });
                    this.displayDialog = false;
                    this.selectedVehicles = [];
                    this.$notify({
                        type: 'success',
                        title: "Requêtes d'inspection créées !"
                    });
                } else {
                    return false;
                }
            });
        },
        tableRowStyle(row) {
            let status = this.getVehicleInspectionStatus(row.row).toLowerCase();
            if (this.colorsConfigStatuses.includes(status)) {
                return { backgroundColor: this.colorsConfig[status].color };
            }
            return {};
        },
    }
};
</script>

<style lang="scss">
.inspections-page {
    .button-container {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        margin-top: 20px;

        .download-out-of-fleet-csv-button {
            height: 50px;
        }
    }

    .inspection-detail-container {
        display: flex;
        ;
        align-items: center;
        justify-content: space-between;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Vehicles/Index.vue